console.log('Header script loaded!');

// Facebook Pixel Code

const getCookie = (name) => {
    const cookieArr = document.cookie.split(";");
    for (const cookie of cookieArr) {
        const [key, value] = cookie.split("=").map(item => item.trim());
        if (name === key) {
            return decodeURIComponent(value);
        }
    }
    return null;
};

const setCookie = (cname, cvalue, exdays) => {
    const expires = new Date(Date.now() + exdays * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${cname}=${cvalue}; expires=${expires}; path=/`;
};

! function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
        n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
}(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1082093382282683');
const queryString1 = window.location.search;
const urlParams1 = new URLSearchParams(queryString1);
if (urlParams1.get("utm_source") == "facebook") {
    if (getCookie("eventID") == null) {/*NOT GENERATED YET*/
    var d = new Date();
    var month = d.getMonth()+1;
    var day = d.getDate();
    var output =  Math.floor((Math.random() * 1000) + 1) + '-' + d.getFullYear() + '-' +
    (month<10 ? '0' : '') +  month + '-' +
    (day<10 ? '0' : '') + day + '-' + d.getHours()+ "-" + d.getMinutes() + "-" + d.getSeconds()+ '-' + Math.floor((Math.random() * 1000) + 1);/*GENERATING*/
    setCookie("eventID", output, 30);/*SAVING TO COOKIE*/
    }
}
fbq('track','PageView', {},{eventID: getCookie("eventID")});

console.log('#debug: End Header script!');

// gclid integration Code
const queryString4 = window.location.search;
const urlParams4 = new URLSearchParams(queryString4);

// Check if gclid exists in the URL
if (urlParams4.get("gclid")) {
    if (getCookie("gclid") == null) { // If the "gclid" cookie has not been created yet
        const gclidValue = urlParams4.get("gclid"); // Get the gclid value
        setCookie("gclid", gclidValue, 30); // Save it as a cookie for 30 days
    }
}


// jQuery v3.6.0
import $ from 'jquery';


/*
jQuery(document).ready(function ($) {
        $(".menu-trigger.mobile-show").click(function () {
            $(".mobile-menu.mobile-show").toggleClass("visible");
                                            $(".menu-trigger.mobile-show").toggleClass("visible");
        });
                                    $(".language-switcher.hovered").click(function () {
            $(".language-switcher.hovered").toggleClass("hovered");
        });
    });
*/